import {
  BARCODE_SAMPLE_FILE,
  LOST_BARCODE_REQUIRED_KEYS,
} from "../../../../../constants/defaultValues";
import { downloadExcelFileWithHeaders } from "../../../../../constants/utils";
import atoms from "../../../../atoms";
import { LostBarcodeTopSectionProps } from "../interface";

const { Input, Button } = atoms;

const LostBarcodeTopSection = ({
  handleFileUpload,
}: LostBarcodeTopSectionProps) => {
  return (
    <div className="d-flex justify-content-between">
      <div className="px-2 d-flex gap-3 align-items-center">
        <label className="inputs-label mb-2 fs-16 fw-600  secondary-color">
          {"Upload XLSX File"}
        </label>
        <Input
          type="file"
          id="formFile"
          accept=".xlsx, .xls, .csv"
          multiple={true}
          onChange={handleFileUpload}
          placeholder={"formate :- .xlsx, .xls"}
          onClick={(e: any) => (e.target.value = null)}
        />
      </div>
      <div>
        <Button
          onClick={() =>
            downloadExcelFileWithHeaders(
              BARCODE_SAMPLE_FILE,
              LOST_BARCODE_REQUIRED_KEYS
            )
          }
        >
          Download Format{" "}
        </Button>
      </div>
    </div>
  );
};

export default LostBarcodeTopSection;
